import React, { useEffect, useState, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import { ToastContainer } from "react-toastify";
import BASE_URL from "../../../config/api";
import "./WatchLesson.css";
import ReactPlayer from "react-player";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Input from "@mui/joy/Input";
import CheckIcon from "@mui/icons-material/Check";
import theme from "../../../themes/theme";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { AppContext } from "../../../context/AppContext";
import { ThemeProvider } from "@emotion/react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";

const WhatchLesson = () => {
  const { courseId, sectionId, lessonId } = useParams();
  const { token } = useContext(AppContext);
  const [githubUrl, setGithubUrl] = useState("");
  const [lesson, setLesson] = useState(null);
  const [sectionLessons, setSectionLessons] = useState([]);
  const [selectedLessonIndex, setSelectedLessonIndex] = useState(null);
  const [activeSection, setActiveSection] = useState("overview");

  const handleButtonClick = (section) => {
    setActiveSection(section);
  };
  const submitTask = async () => {
    try {
      await axios.post(
        `${BASE_URL}/courses/${courseId}/sections/${sectionId}/lessons/${lessonId}/tasks`,
        {
          taskLink: githubUrl,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Task submitted successfully!");
    } catch (error) {
      toast.error("Tasks are disabled for this lesson");
    }
  };
  const completeLesson = async () => {
    if (token) {
      try {
        await axios.post(
          `${BASE_URL}/courses/${courseId}/sections/${sectionId}/lessons/${lessonId}/attendance/self`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Lesson completed");
      } catch (error) {
        toast.error(error.response.data.error);
      }
    }
  };

  useEffect(() => {
    const fetchLessonById = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/courses/${courseId}/sections/${sectionId}/lessons/${lessonId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLesson(response.data);
      } catch (error) {
        // console.log("error", error.response.data);
      }
    };

    const fetchSectionLessons = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/courses/${courseId}/sections/${sectionId}/lessons`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSectionLessons(response.data);
      } catch (error) {
        // console.error(error);
      }
    };
    if (token) {
      fetchLessonById();
      fetchSectionLessons();
    }
  }, [token, courseId, sectionId, lessonId]);

  useEffect(() => {
    const lessonIndex = sectionLessons.findIndex((sectionLesson) => sectionLesson._id === lessonId);
    setSelectedLessonIndex(lessonIndex);
  }, [lessonId, sectionLessons]);

  if (!lesson || sectionLessons.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div className="lesson-container">
      <div className="lesson-container-left">
        <div className="video-container">
          <ReactPlayer width={"100%"} height={"100%"} controls={true} url={lesson.videoUrl} playing={selectedLessonIndex !== null} />
        </div>
        <div className="buttons-box">
          <ThemeProvider theme={theme}>
            <Button onClick={() => handleButtonClick("overview")} variant={activeSection === "tasks" ? "overlined" : "contained"}>
              Overview
            </Button>
          </ThemeProvider>
          <ThemeProvider theme={theme}>
            <Button onClick={() => handleButtonClick("tasks")} variant={activeSection === "tasks" ? "contained" : "overlined"}>
              Tasks
            </Button>
          </ThemeProvider>
          <ThemeProvider theme={theme}>
            <Button sx={{ border: "none" }} variant="contained" color="success" onClick={completeLesson} startIcon={<CheckIcon />}>
              Complete Lesson
            </Button>
          </ThemeProvider>
        </div>

        <div className="lesson-details">
          {activeSection === "overview" && (
            <>
              <h2>{lesson.title}</h2>
              <p>{lesson.description}</p>
            </>
          )}
          {activeSection === "tasks" && (
            <div className="tasks-section">
              <h2>Submit your tasks for this lesson</h2>
              <label className="label-tasks">Url to your github repository</label>
              <Input variant="soft" placeholder="Paste url here" value={githubUrl} onChange={(e) => setGithubUrl(e.target.value)}></Input>
              <ThemeProvider theme={theme}>
                <Button variant="contained" onClick={submitTask}>
                  Submit
                </Button>
              </ThemeProvider>
            </div>
          )}
        </div>
      </div>
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
      <div className="sections-table">
        <p className="title-lesson" style={{ fontSize: "1.5rem", fontWeight: "700", color: "#0e1937" }}>
          Lessons that you can play
        </p>
        <List>
          {sectionLessons.map((sectionLesson, index) => (
            <ListItem style={{ color: "#0E1937" }} key={sectionLesson._id} selected={index === selectedLessonIndex} component={Link} to={`/course/${courseId}/section/${sectionId}/lesson/${sectionLesson._id}`}>
              <ListItemIcon>{index === selectedLessonIndex ? <PauseCircleIcon style={{ color: "#0E1937" }} /> : <PlayCircleIcon style={{ color: "#0E1937" }} />}</ListItemIcon>
              <ListItemText primary={sectionLesson.title} style={{ paddingRight: "5px" }} />
              <div>
                <ListItemText primary={sectionLesson.duration} />
              </div>
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};

export default WhatchLesson;
